var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-right"},[_c('base-button',{staticClass:"btn-fill text-right",attrs:{"type":"warning","size":"md"},on:{"click":_vm.doRefresh}},[_vm._v("\n      GENERATE TABLE\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }